<template>
  <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          {{ $$t('new') }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $$t('title') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  :label="$$t('name')"
                  v-model="localItem.name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="dialog = false"
          >
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            @click="dialog = false;$emit('save', localItem);localItem.name = '';"
          >
            {{ $t('common.buttons.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ModalArea',
  module: 'Membership',
  data() {
    return {
      dialog: false,
      localItem: {
        name: '',
        orgId: this.organization?.id,
      },
    };
  },
  computed: {
    ...mapState('organizations', ['organization']),
  },
  methods: {
    organizationChanged(o) {
      this.$log.info('component detected organization changed', o);
      this.localItem.orgId = this.organization?.id;
    },
  },
  mounted() {
    this.localItem.orgId = this.organization?.id;
  },
};
</script>
